import { FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useGetMe } from 'src/api/user';
import { PageLoader } from 'src/components/PageLoader';

import { routes } from '../routes';

const { dashboard } = routes;

const LoggedOutRoutesGuard: FC = () => {
  const location = useLocation();
  const { data: userData, isPending } = useGetMe();

  if (isPending) {
    return <PageLoader visible />;
  }

  if (userData && userData.is_activated && userData.is_active) {
    return <Navigate to={dashboard} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default LoggedOutRoutesGuard;
